// extracted by mini-css-extract-plugin
export default {"addToCartControl":"C2-z","giftCard":"D2-z","btnContainer":"E2-z","cartButton":"F2-z","disabled":"G2-z"};